import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import { save, setLoginInfo, setToken } from "../../features/auth/authSlice";
import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import svg106 from "../../assets/svg/svg106.svg";
import svg77 from "../../assets/svg/svg77.svg";
import svg85 from "../../assets/svg/svg85.svg";
import { getInitials } from "../../utils";
import ndovuHr from "../../assets/img/ndovuPayShield.png";
import axiosInstance from "../../instance";

export default function SelectOrganization() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { accountInfo, saving } = useSelector((state) => state.auth);
  const formRef = useRef(null);

  const handleLogin = async () => {
    await navigate("/login");
  };

  const handleClick = async (data) => {
    const res = await dispatch(
      save({
        url: "usr/post_select_org.action",
        usrId: data?.usrId,
        orgId: data?.orgId,
      }),
    );
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      if (res?.payload?.otpRequired) {
        await dispatch(setLoginInfo(res?.payload?.jsonData));
        await navigate("/login-otp");
      } else {
        await dispatch(setToken(res?.payload?.token));
        axiosInstance.defaults.headers.common["Authorization"] =
          await `${res?.payload?.token}`;

        await navigate("/dashboard-main");
      }
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (accountInfo?.usrUsername) {
      form.setFieldsValue({
        usrUsername: accountInfo?.usrUsername,
      });
    }
  }, [accountInfo, form]);
  return (
    <div className="flex h-[100vh] w-full overflow-y-scroll">
      <div
        className={`w-[50%] h-screen lg:flex hidden justify-center items-center login-pic }`}
      ></div>
      <div className="bg-[#f4f5f7] lg:w-[50%] w-full flex flex-col justify-center items-center lg:px-[10%] px-3">
        <div className="image-container">
          <img
            loading="lazy"
            decoding="async"
            src={ndovuHr}
            alt="logo"
            className="w-[400px]  h-[250px] object-contain animated-image"
          />
        </div>
        <span className={`heading_1`}>Select Organization</span>
        <span className="paragraph_4 mt-[1.13rem]">
          Please choose an organization you want to proceed with
        </span>
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          style={{
            maxWidth: "100%",
            marginTop: "2.06rem",
            width: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="usrUsername"
            label="Username"
            rules={[
              {
                required: true,
                message: "Username is required to login",
              },
            ]}
          >
            <Input
              readOnly
              prefix={<img src={svg77} alt="svg77" />}
              type="email"
              className="input"
            />
          </Form.Item>

          <div className="mt-[2.5rem]">
            {accountInfo?.orgOptions &&
              accountInfo?.orgOptions?.map((item) => (
                <div
                  onClick={() => handleClick(item)}
                  className="group border border-[#E5E7EB] hover:border-[#FFB600] rounded-[1rem] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] py-[1.5rem] px-[2rem] mb-[1.25rem] cursor-pointer transition-colors duration-200"
                >
                  <div className="flex justify-between items-center">
                    <div className="flex gap-[1rem]">
                      <div className="w-[2.8125rem] h-[2.8125rem] rounded-full bg-[#FFB600]/10 text-[#FFB600] text-[1.125rem] font-[400] leading-[1.575rem] flex items-center justify-center">
                        {getInitials(item?.orgName)}
                      </div>
                      <div className="flex flex-col">
                        <div className="text-[#111827] text-[1rem] font-[400] leading-normal">
                          {item?.orgName}
                        </div>
                        <div className="flex items-center gap-[.5rem] text-[#4B5563] text-[.875rem] font-[300] leading-normal">
                          <span>{item?.industryName ?? "Organization"}</span>
                          <span>•</span>
                          <span>{item?.orgCode}</span>
                        </div>
                      </div>
                    </div>

                    <div className="w-[1.5rem] h-[1.5rem] rounded-full bg-[#FFB600]/10 items-center justify-center hidden group-hover:flex">
                      <img className="w-5 h-5" src={svg106} alt="svg106" />
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div className="w-full justify-center flex mt-[2.5rem]">
            <div
              onClick={handleLogin}
              className="text-xs sm:text-sm lg:text-[0.875rem] text-[#2F2B43] font-[400] flex items-center  cursor-pointer gap-[0.5rem] font-dmSans"
            >
              <span className="flex justify-center items-center gap-2">
                <img src={svg85} alt="svg85" /> Back{" "}
              </span>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}
